// Kova-web values from the Figma "Kova-Growth" variables that the growth-ds token bundle doesn't ship
// (its Kova brand block only overrides the base, brand and accent colours). Pass them straight to the DS
// props — `Text`'s `color` / `font` and `LayoutFlex`'s `box-shadow` take raw CSS as well as token names.
// Literal until the DS gets a Kova token set; see docs/architecture/styles.md → "Kova-web values".
export const KOVA = {
	/** `text/black/secondary` — the grey of secondary lines (the DS `--text-dark-secondary` is 0.6). */
	textSecondary: 'rgba(50, 54, 83, 0.55)',
	/** `text/secondary` — the 0.6 grey some frames use for sub-lines ("Fully paid"). */
	textSecondary60: 'rgba(50, 54, 83, 0.6)',
	/** `text/black/disabled` — rows not reached yet (the DS `--text-dark-tertiary` is 0.4). */
	textDisabled: 'rgba(50, 54, 83, 0.32)',
	/**
	 * `border/black` under a section. Figma draws the stroke inside the frame, so it takes no space: an
	 * inset shadow, not a `border`, which would add a pixel per divider.
	 */
	divider: 'inset 0 -1px 0 rgba(50, 54, 83, 0.15)',
	/** `status/purple/bg` + `text/accent/purple` — the "under clinical review" banner (the DS violet is bluer). */
	purpleBg: 'rgba(172, 100, 210, 0.2)',
	purple: '#8a4aaa',
	/** `status/error/bg` — the pink "You’ll lose access to:" card (the DS rose tints are 8% / 20%). */
	errorBg: 'rgba(203, 49, 82, 0.1)',
	/** `text/20/24/semi` — the plan name; the DS has 18/22 and 20/26 only. */
	font20x24Semi: 'normal var(--fw-semi) var(--20)/var(--lh-24) var(--font-default)',
} as const
